import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: '0px !important',
        background: '#4c4fa6 !important',
        color: '#fff !important',
        padding: '6px 48px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important'
    }
}));

export default function IdleTimeOutModal({ showModal, handleClose, handleLogout }) {
    // const history = useHistory();
    const classes = useStyles();

    return (
        <Dialog
            onClose={handleClose}
            PaperProps={{
                className: 'QandADailogBox',
                style: { padding: '20px' },
            }}
            aria-labelledby="form-dialog-title"
            open={showModal}
            onBackdropClick={handleLogout}
        >
            <p className="filename" style={{ padding: '0px 11px' }}>
                Your session is about to expire, if you wish to continue please click on continue session
            </p>
            <DialogActions className="paddingBtm txtCenter">
                <Button className={classes.button} onClick={handleLogout} variant="contained" component="label" color="default">
                    Logout
                </Button>
                <Button className="btnBluepop" onClick={handleClose} variant="contained" component="label" color="default">
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}
